import { runInAction } from "mobx";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import Box from "../../../Styled/Box";
import { useViewState } from "../../Context";
import DataCatalog from "../../DataCatalog/DataCatalog";
import DataPreview from "../../Preview/DataPreview";
import Breadcrumbs from "../../Search/Breadcrumbs";
import SearchBox, { DEBOUNCE_INTERVAL } from "../../Search/SearchBox";
import Styles from "./data-catalog-tab.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DataCatalogTab = observer(function DataCatalogTab(props) {
  const viewState = useViewState();
  const {
    t
  } = useTranslation();
  const {
    searchState,
    previewedItem: previewed,
    breadcrumbsShown: showBreadcrumbs,
    terria
  } = viewState;
  const searchPlaceholder = props.searchPlaceholder || t("addData.searchPlaceholder");
  const changeSearchText = newText => {
    runInAction(() => {
      viewState.searchState.catalogSearchText = newText;
    });
  };
  const search = () => {
    viewState.searchState.searchCatalog();
  };
  return /*#__PURE__*/_jsx("div", {
    className: Styles.root,
    children: /*#__PURE__*/_jsxs(Box, {
      fullHeight: true,
      column: true,
      children: [/*#__PURE__*/_jsxs(Box, {
        fullHeight: true,
        overflow: "hidden",
        children: [/*#__PURE__*/_jsxs(Box, {
          className: Styles.dataExplorer,
          styledWidth: "40%",
          children: [searchState.catalogSearchProvider && /*#__PURE__*/_jsx(SearchBox, {
            searchText: searchState.catalogSearchText,
            onSearchTextChanged: changeSearchText,
            onDoSearch: () => search(),
            placeholder: searchPlaceholder,
            debounceDuration: terria.catalogReferencesLoaded ? searchState.catalogSearchProvider.debounceDurationOnceLoaded : DEBOUNCE_INTERVAL
          }), /*#__PURE__*/_jsx(DataCatalog, {
            terria: terria,
            viewState: viewState,
            onActionButtonClicked: props.onActionButtonClicked,
            items: props.items
          })]
        }), /*#__PURE__*/_jsx(Box, {
          styledWidth: "60%",
          children: /*#__PURE__*/_jsx(DataPreview, {
            terria: terria,
            viewState: viewState,
            previewed: previewed
          })
        })]
      }), showBreadcrumbs && /*#__PURE__*/_jsx(Breadcrumbs, {
        terria: terria,
        viewState: viewState,
        previewed: previewed
      })]
    })
  });
});
export default DataCatalogTab;